import { OpStatus } from 'NSwag/ServerClient/Client.nswag';

/**
 * Gets the status color of an opStatus for UI styling.
 * @param opStatus - The given operating status enum value.
 * @returns A visible color string.
 */
export const getOpStatusColor = (opStatus: OpStatus): string => {
    let color = opStatusColorMap.get(opStatus);
    if (!color) {
        color = opStatusColorMap.get(OpStatus.NULL)!;
    }
    return color;
}

/**
 * A mapping of the OpStatus Enum values to a color represented by a string.
 */
export const opStatusColorMap: Map<OpStatus, string> = new Map([
    [OpStatus.Active, 'green'],
    [OpStatus.Failed, 'red'],
    [OpStatus.Error, 'red'],
    [OpStatus.OutOfService, 'grey'],
    [OpStatus.NULL, 'grey']
]);

/**
 * Gets the OpStatus member as a string.
 * @param opStatus - The OpStatus member string.
 */
export const getOpStatusDescription = (opStatus: OpStatus): string => {
    let description = opStatusDescriptionMap.get(opStatus);
    if (!description) {
        description = opStatusDescriptionMap.get(OpStatus.NULL)!;
    }
    return description;
}

/**
 * A mapping of the OpStatus Enum values to their member names represented as strings.
 */
export const opStatusDescriptionMap: Map<OpStatus, string> = new Map([
    [OpStatus.Active, 'Active'],
    [OpStatus.Failed, 'Failed'],
    [OpStatus.NotSet, 'Not Set'],
    [OpStatus.Error, 'Error'],
    [OpStatus.OutOfService, 'Out of Service'],
    [OpStatus.NULL, 'Unknown']
]);

/**
 * Gets the OpStatus member name as a string.
 * @param opStatus - The OpStatus as a string, or an undefined value.
 * @returns The matching OpStatus member value.
 */
export const getOpStatusFromString = (opStatus: string | undefined): OpStatus => {
    if (opStatus == undefined) {
        return OpStatus.NULL;
    } else {
        let description = descriptionToOpStatusMap.get(opStatus as string);
        if (!description) {
            description = OpStatus.NULL;
        }

        return description;
    }
}

/**
 * A mapping of the OpStatus member strings to member values.
 */
export const descriptionToOpStatusMap: Map<string, OpStatus> = new Map([
    ['Active', OpStatus.Active],
    ['Failed', OpStatus.Failed],
    ['Not Set', OpStatus.NotSet],
    ['Error', OpStatus.Error],
    ['Out of Service', OpStatus.OutOfService],
    ['Unknown', OpStatus.NULL]
]);